import { render, staticRenderFns } from "./FieldIndex.vue?vue&type=template&id=fbc6aaf0"
import script from "./FieldIndex.vue?vue&type=script&lang=js"
export * from "./FieldIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports